import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import {
  getLabelMappings,
  getLabelRoles,
  getRepoLabels,
  type ImportedLabelsResponse,
  type LabelMappingsResponse,
  type LabelRolesResponse,
} from "./labelMappingApi";

// Хук для GET /settings/label-mappings — строки маппинга одного scope.
// Org-scoped запрос (см. `src/query/scope.ts`); ключ несёт repo
// (org-дефолт vs override конкретного репо — разные scope). Ключ без
// `forgejo` — маппинг провайдер-нейтрален.
export function useLabelMappings(
  repo: string | null,
): UseQueryResult<LabelMappingsResponse, Error> {
  return useOrgScopedQuery<LabelMappingsResponse>({
    key: ["settings", "label-mappings", repo],
    queryFn: () => getLabelMappings(repo),
    retry: false,
  });
}

// Хук для GET /settings/label-mappings/roles — каталог ролей меток и
// правило обязательности `role_value`. Org-scoped запрос (ручка требует
// активной организации); ключ не совпадает по префиксу с ключом маппинга.
export function useLabelRoles(): UseQueryResult<LabelRolesResponse, Error> {
  return useOrgScopedQuery<LabelRolesResponse>({
    key: ["settings", "label-roles"],
    queryFn: getLabelRoles,
    retry: false,
  });
}

// Хук для GET /connections/task-tracker/repos/{owner}/{name}/labels —
// метки подключённого репозитория.
//
// Импорт ходит в сеть под connection-credential'ом — стартует только
// когда выбран конкретный repo (org-scope меток не импортирует, ходить
// некуда). Org-scoped запрос (см. `src/query/scope.ts`); ключ несёт repo.
export function useRepoLabels(
  repo: string | null,
): UseQueryResult<ImportedLabelsResponse, Error> {
  return useOrgScopedQuery<ImportedLabelsResponse>({
    key: ["connections", "task-tracker", "repo-labels", repo],
    queryFn: () => getRepoLabels(repo!),
    enabled: repo !== null,
    retry: false,
  });
}
